import { ColumnDef } from "@tanstack/react-table";

import { ViewTSCSchema } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { convertToCamelCase } from "src/helpers";

export const columns: ColumnDef<ViewTSCSchema>[] = [
  {
    accessorKey: "_id",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Existing TOD Zones" />,
    cell({
      row: {
        original: { _id },
      },
    }) {
      return <>{convertToCamelCase(_id)}</>;
    },
  },

  {
    accessorKey: "main_meter_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Main Meter Units" />,
    cell({
      row: {
        original: { main_meter_units },
      },
    }) {
      return <>{main_meter_units?.toFixed(2)}</>;
    },
  },
  {
    accessorKey: "main_meter_over_inj_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Over Injection Units " />,
    cell({
      row: {
        original: { main_meter_over_inj_units },
      },
    }) {
      return <>{main_meter_over_inj_units?.toFixed(2)}</>;
    },
  },
  {
    accessorKey: "main_meter_bank_offset_units",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Bank Offset Units" />,
    cell({
      row: {
        original: { main_meter_bank_offset_units },
      },
    }) {
      return <>{main_meter_bank_offset_units?.toFixed(2)}</>;
    },
  },
];
